import React from 'react';
import { MapPin, Building2, GraduationCap } from 'lucide-react';

const StateTrainingCenters = () => {
  const [isTamil, setIsTamil] = React.useState(false);

  const translations = {
    en: {
      title: "STATE TRAINING CENTRES- TAMIL NADU",
      subtitle: "Official Training Locations",
      description: "Our state training centers are equipped with modern facilities to provide comprehensive training for scouts and guides.",
      columnHeaders: {
        sno: "S.No",
        center: "Camp Centre & Place",
        action: "Action"
      },
      stats: {
        title: "Training Center Statistics",
        centers: "Training Centers",
        districts: "Districts Covered",
        capacity: "Total Capacity"
      },
      bookNow: "Book Now",
      centers: [
        {
          id: 1,
          type: "STATE HEAD QUARTERS",
          location: "Wenlock Park",
          place: "Triplicane,Chennai"
        },
        {
          id: 2,
          type: "STATE TRAINING CENTRES",
          location: "STANLEY PARK",
          place: "Coonoor"
        },
        {
          id: 3,
          type: "STATE TRAINING CENTRES",
          location: "Alathur",
          place: "Chengalpattu District"
        }
      ]
    },
    ta: {
      title: "மாநில பயிற்சி மையங்கள்- தமிழ்நாடு",
      subtitle: "அதிகாரப்பூர்வ பயிற்சி இடங்கள்",
      description: "எங்கள் மாநில பயிற்சி மையங்கள் சாரணர்கள் மற்றும் சாரணியர்களுக்கு விரிவான பயிற்சி வழங்க நவீன வசதிகளுடன் உள்ளன.",
      columnHeaders: {
        sno: "வ.எண்",
        center: "முகாம் மையம் & இடம்",
        action: "நடவடிக்கை"
      },
      stats: {
        title: "பயிற்சி மைய புள்ளிவிவரங்கள்",
        centers: "பயிற்சி மையங்கள்",
        districts: "மாவட்டங்கள்",
        capacity: "மொத்த கொள்ளளவு"
      },
      bookNow: "இப்போது பதிவு செய்க",
      centers: [
        {
          id: 1,
          type: "மாநில தலைமையகம்",
          location: "வென்லாக் பார்க்",
          place: "திருவல்லிக்கேணி, சென்னை"
        },
        {
          id: 2,
          type: "மாநில பயிற்சி மையங்கள்",
          location: "ஸ்டான்லி பார்க்",
          place: "கூனூர்"
        },
        {
          id: 3,
          type: "மாநில பயிற்சி மையங்கள்",
          location: "ஆலத்தூர்",
          place: "செங்கல்பட்டு மாவட்டம்"
        }
      ]
    }
  };

  const t = translations[isTamil ? 'ta' : 'en'];

  const handleBookNow = (center) => {
    alert(`Booking for: ${center.type} - ${center.location}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Language Toggle */}
        <div className="flex justify-end mb-4">
          <button
            onClick={() => setIsTamil(!isTamil)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
          >
            {isTamil ? 'English' : 'தமிழ்'}
          </button>
        </div>

        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className={`text-3xl font-bold text-gray-900 mb-4 ${isTamil ? 'text-2xl' : ''}`}>
            {t.title}
          </h1>
          <p className={`text-xl text-gray-600 ${isTamil ? 'text-lg' : ''}`}>
            {t.subtitle}
          </p>
          <p className={`mt-4 max-w-2xl mx-auto text-gray-500 ${isTamil ? 'text-sm' : ''}`}>
            {t.description}
          </p>
        </div>

        {/* Stats Section */}
        <div className="mb-12 grid grid-cols-1 gap-5 sm:grid-cols-3">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-blue-500 rounded-md p-3">
                  <Building2 className="h-6 w-6 text-white" />
                </div>
                <div className="ml-5">
                  <dl>
                    <dt className={`text-sm font-medium text-gray-500 truncate ${isTamil ? 'text-xs' : ''}`}>
                      {t.stats.centers}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">3</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-500 rounded-md p-3">
                  <MapPin className="h-6 w-6 text-white" />
                </div>
                <div className="ml-5">
                  <dl>
                    <dt className={`text-sm font-medium text-gray-500 truncate ${isTamil ? 'text-xs' : ''}`}>
                      {t.stats.districts}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">3</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-purple-500 rounded-md p-3">
                  <GraduationCap className="h-6 w-6 text-white" />
                </div>
                <div className="ml-5">
                  <dl>
                    <dt className={`text-sm font-medium text-gray-500 truncate ${isTamil ? 'text-xs' : ''}`}>
                      {t.stats.capacity}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">500+</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Table */}
        <div className="bg-white shadow-lg rounded-lg overflow-hidden mb-12">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-800">
                <tr>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.sno}
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.center}
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.action}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {t.centers.map((center) => (
                  <tr key={center.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {center.id}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      <div className="font-medium">{center.type}</div>
                      <div className="mt-1">
                        "{center.location}" {center.place}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <button 
                        onClick={() => handleBookNow(center)}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors duration-200 shadow-sm hover:shadow-md"
                      >
                        {t.bookNow}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateTrainingCenters;